import Home from './Home.pid-bank.vue'

export default {
  Home
}